import { URLS } from '@/constants';
import { IngestionBatch, IngestionItem } from '@/models/admin';
import { PaginatedResponse } from '@/models/api';
import { OrderCoOrganization } from '@/services/api/models/admin';
import buildPath from '@/utils/buildPath';
import JSONTransform from '@/utils/json-transform';

import session, { createSession } from '../session';
import { GetIngestionItemsArgs } from './models/productIngestion';

/**
 * Get Ingestion Batches (a CSV upload attempt from a staff user)
 * @returns paginated IngestionBatches
 */
export const getIngestionBatches = async (serializedParams: string) => {
  const url = `${URLS.ADMIN.PRODUCT_CSV_INGESTION}/?${serializedParams}&${URLS.CUSTOM_ERROR}`;
  const session = createSession('');
  const response = await session.get<PaginatedResponse<IngestionBatch>>(url);

  return response.data;
};

export const getIngestionItems = async ({ ingestionId, serializedParams }: GetIngestionItemsArgs) => {
  const path = buildPath(URLS.ADMIN.PRODUCT_CSV_INGESTION_ITEM, { id: ingestionId });
  const url = `${path}/?${URLS.CUSTOM_ERROR}&${serializedParams}`;
  const session = createSession('');
  const response = await session.get<PaginatedResponse<IngestionItem>>(url);

  return response.data;
};

export interface GetOrderCoOrganizationsArgs {
  params: {
    page: number;
    pageSize: number;
    search?: string;
    ordering?: string;
  };
}

export const getOrderCoOrganizations = async ({ params }: GetOrderCoOrganizationsArgs) => {
  const url = `${URLS.ADMIN.ORDER_CO.BASE}/${URLS.ADMIN.ORDER_CO.ORGANIZATIONS}/`;
  const session = createSession(URLS.INTERNAL);
  const paramsFormatted = new JSONTransform({ errorFormat: 'jsonapi', ...params }).toSnakeCaseKeys();
  const response = await session.get<PaginatedResponse<OrderCoOrganization>>(url, { params: paramsFormatted });

  return response.data;
};

export const postPackageInspector = async (params: string) => {
  const response = await session.post<Record<string, unknown>>(URLS.ADMIN.METRC_PACKAGE_INSPECTOR, params);

  return response.data;
};
